var makeString = require('./helper/makeString');

module.exports = function titleize(str) {
  return makeString(str).toLowerCase().replace(/(?:^|\s|-)\S/g, function(c) {
    return c.toUpperCase();
  });
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/titleize.js
// module id = 440
// module chunks = 0